import { styled } from '@mui/system'
import { Box, Typography } from '@vapor/material'

export const EditableBox = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  border: '1px solid var(--AzureishWhite)',
  borderRadius: '5px',
  height: '100%',
  cursor: 'pointer',
  '&:hover': { border: '1px solid var(--RichElectricBlue)' },
}))

export const TypographyCode = styled(Typography)(({ theme }) => ({
  fontFamily: 'Courier',
  fontSize: '0.8rem',
  fontWeight: 'bold',
}))
